export default __webpack_public_path__ + "static/shop-best-sellers-588c77a2e7980d2337f79212fa8a217e.webp";